/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class GroupGrid extends NoboxEntityGrid<GroupRow, any> {
        protected getColumnsKey() { return GroupColumns.columnsKey; }
        protected getDialogType() { return GroupDialog; }
        protected getIdProperty() { return GroupRow.idProperty; }
        protected getInsertPermission() { return GroupRow.insertPermission; }
        protected getLocalTextPrefix() { return GroupRow.localTextPrefix; }
        protected getService() { return GroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            buttons.splice(0, 1);
            return buttons;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            return true;
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let account = Q.getLookup("Nobox.AccountLookup").itemById as unknown;

            Q.first(columns, x => x.field == GroupRow.Fields.AccountIds).format =
                ctx => {
                    let idList = ctx.value;
                    if (!idList)
                        return "";

                    idList = idList.split(",") as string[]
                    var elList = "";
                    var idLast = 0;
                    idList.forEach(function (x) {
                        if (!Q.isEmptyOrNull(x)) {
                            let g = account[BigInt(x)] as any;
                            idLast = x;
                            if (!g) {
                                elList += `<span data-id="${x.toString()}" class="list-link">${x.toString()}, </span>`;
                            } else {
                                elList += `<span data-id="${x.toString()}" class="list-link">${Q.htmlEncode(g.Name)}, </span>`;
                            }
                        }
                    });
                    if (account[BigInt(idLast)]) {
                        return `<a href="javascript:;" class="link-group">${elList.replace(account[BigInt(idLast)].Name + ", ", account[BigInt(idLast)].Name)}</a>`;
                    } else {
                        return `<a href="javascript:;" class="link-group">${elList.replace(idLast.toString() + ", ", idLast.toString())} </a>`;
                    }
                };

            return columns;
        }
        protected onClick(e, row, cell) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented()) {
                return;
            }

            var item = this.itemAt(row);
            var target = $(e.target);
            if (target.hasClass(`link-group`)) {
                e.preventDefault();

                Q.notifySuccess(`Success filter by Account`);
                var formFilterDt = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    "AccountIds");
                formFilterDt.set_value(item.AccountIds.toString());
                this.refresh();
            } else if (target.parent().hasClass(`link-group`)) {
                e.preventDefault();

                Q.notifySuccess(`Success filter by Account`);
                var formFilterDt = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    "AccountIds");
                formFilterDt.set_value(item.AccountIds.toString());
                this.refresh();
            }
        }
    }
}